<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="奖励类型：">
            <el-select v-model="query.rewardType" placeholder="请选择" clearable size="small">
              <el-option label="商品" :value="1"></el-option>
              <el-option label="零售价" :value="2"></el-option>
              <el-option label="无奖励" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否限制时间">
            <el-select v-model="query.isLimit" placeholder="请选择" clearable size="small">
              <el-option label="限制" :value="true"></el-option>
              <el-option label="不限制" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="套餐类型：">
            <el-select v-model="query.activityType" placeholder="请选择" clearable size="small">
              <el-option label="充值套餐" :value="0"></el-option>
              <el-option label="直播套餐" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="query.state" placeholder="请选择" clearable size="small">
              <el-option label="已上架" :value="true"></el-option>
              <el-option label="已下架" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs></el-tabs>
        <div class="btn-box">
          <el-dropdown @command="handleCommand">
            <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="beforeHandleCommand(row,false)">批量下架</el-dropdown-item>
              <el-dropdown-item :command="beforeHandleCommand(row,true)">批量上架</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新增充值</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <el-table-column type="selection" width="50" />
        <el-table-column label="活动名称" prop="activityName" align="center" width="120">
          <template slot-scope="{row}">
            <span>{{row.activityName || ''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="充值金额" prop="rechargeMoney" align="center" width="80">
          <template slot-scope="{row}">
            <el-link type="primary" @click="handleShow(row)">{{row.rechargeMoney}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="套餐类型" prop="activityType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.activityType==0?'充值套餐':row.activityType==1?'直播套餐':'充值套餐' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="充值类型" prop="rechargeType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.rechargeType || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="获得奖励" prop="rewardType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.rewardType==1?'商品':row.rewardType==2?'零售价':'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否限制时间" prop="isLimit" align="center">
          <template slot-scope="{row}">
            <span>{{ row.isLimit?'限制':'不限制' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="套餐上架时间" prop="startTime" sortable align="center" width="300">
          <template slot-scope="{row}">
            <span>{{ row.showTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" prop="state" align="center">
          <template slot-scope="{row}">
            <el-switch
              v-model="row.state"
              @change="changeSwitch(row)"
              :active-text="row.state?'已上架':'已下架'">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdTime" sortable align="center"></el-table-column>
        <el-table-column label="修改时间" prop="operatedTime" sortable align="center"></el-table-column>
        <el-table-column label="操作人" prop="operatedByName" align="center"></el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200px">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleUpdate(row,1)">编辑</el-button>
            <el-button type="text" @click="handleDeleteSingle(row)">删除</el-button>
            <!-- <el-button type="text" @click="handleLog(row,1)">日志记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <rechargeActivity-add ref="rechargeActivityAdd" @created="doQueryList({})" :popType="popType"/>
  </div>
</template>

<script>
  import rechargeActivityAdd from './add'
  import rechargeActivityApi from '@/api/recharge/rechargeActivity'
  import Pagination from '@/components/Pagination'
  export default {
    components: {
      Pagination,
      rechargeActivityAdd
    },
    data() {
      return {
        popType: 0, //0:新增 1:编辑
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          rewardType:'',
          isLimit:'',
          state:''
        },
        selectItems: [],
        activeName: '1',
      }
    },
    created() {
      this.doQueryList({pageNo: 1})
    },
    methods: {
      /**
       * 选择框变化
       */
      selectionChange(val) {
        this.selectItems = val
      },
      /**
       * 列表tab切换
       */
      handleClick() {
        console.log('val: ', this.activeName);
      },

      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 重置
       */
      handleFilter() {
        this.query.rewardType = ''
        this.query.isLimit = ''
        this.query.state = ''
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 获取列表数据
       */
      doQueryList({ pageNo, pageSize }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        this.listLoading = true
        return rechargeActivityApi.fetchList(this.query)
          .then(res => {
            res.data.list.forEach(item => {
              if (item.startTime && item.endTime) {
                // 显示活动的上下架时间（不管是否限制时间）
                item.showTime = `${item.startTime.substring(0,16)}--${item.endTime.substring(0,16)}`;
                item.times = [item.startTime, item.endTime];
              } else {
                // 没有时间数据时显示 -
                item.showTime = '-';
                item.times = '';
              }
            })
            this.list = res.data.list
            this.total = res.data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 删除单条记录
       */
      handleDeleteSingle(row) {
        return this.$common.confirm('是否确认删除')
          .then(() => rechargeActivityApi.deleteById(row.id))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 批量删除记录
       */
      handleDeleteBatch() {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择活动')
          return
        }
        return this.$common.confirm('是否确认删除')
          .then(() => technicianInfoApi.deleteBatch(this.selectItems.map(row => row.id)))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 批量上下架
       */
      beforeHandleCommand(row, command) {
        return {
          'row': row,
          'command': command
        }
      },
      handleCommand(command) {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择充值活动')
          return
        }
        let ids = this.selectItems.map(row => row.id)
        let txt = ""
        this.handleBatchState(ids, command.command)
      },
      handleBatchState(ids, type) {
        let txt = type ? '确认将选中充值活动批量上架？' : '确认将选中充值活动批量下架？'
        this.$common.confirm(txt).then(() => rechargeActivityApi.updateState({ rechargeIdStr: ids.join(','), state: type,endTime:type?this.getTimeAfterYears(100):this.getCurrentTime() }))
          .then(() => {
            this.$common.showMsg('success', '操作成功')
            return this.doQueryList({ pageNo: 1 })
          })
      },
      /**
       * 单个上下架
       */
      changeSwitch(row) {
        if(row.state){
          row.endTime = this.getTimeAfterYears(100);
        }else{
          row.endTime = this.getCurrentTime();
        }
        return rechargeActivityApi.updateState({ rechargeIdStr: row.id+'', state: row.state,endTime:row.endTime }).then(() => {
          this.$common.showMsg('success', '操作成功')
          // 刷新列表以同步更新上下架时间
          return this.doQueryList({})
        })
      },

      /**
       * 打开新建表单
       */
      handleCreate(row) {
        this.popType = 0
        this.$refs.rechargeActivityAdd.handleCreate(row)
      },
      /**
       * 打开查看表单
       */
      handleShow(row) {
        this.$emit('handleShow', row, 2)
      },
      /**
       * 打开编辑表单
       */
      handleUpdate(row, type) {
        // console.log('type: ',type);
        this.popType = type
        this.$refs.rechargeActivityAdd.handleUpdate({
          row,
          command: type
        })
      },
      // 导出
      handleDownload() {
        return this.$common.confirm('是否确认导出')
          .then(() => sysGoodsApi.exportExcel(this.query))
      },
      // 查看日志
      handleLog(row) {

      },
      /**
       * 获取当前时间字符串
       */
      getCurrentTime() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      /**
       * 获取指定年数后的时间字符串
       */
      getTimeAfterYears(years) {
        const now = new Date();
        const futureDate = new Date(now.getFullYear() + years, now.getMonth(), now.getDate(), now.getHours(), now.getMinutes(), now.getSeconds());
        const year = futureDate.getFullYear();
        const month = String(futureDate.getMonth() + 1).padStart(2, '0');
        const day = String(futureDate.getDate()).padStart(2, '0');
        const hours = String(futureDate.getHours()).padStart(2, '0');
        const minutes = String(futureDate.getMinutes()).padStart(2, '0');
        const seconds = String(futureDate.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    }
  }
</script>
